import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import Cfa2SubscriptionCheck from '../../../RestAPI/Cfa2Subscription';
import PartnerCfa2SubscriptionCheck from '../../../RestAPI/PartnerSubscription/Cfa2Subscription';
import Cfa3SubscriptionCheck from '../../../RestAPI/Cfa3Subscription';
import PartnerCfa3SubscriptionCheck from '../../../RestAPI/PartnerSubscription/Cfa3Subscription';

import language from '../../../../assets/languages/language';
import ModalComponent from '../../../Common/Modal';
import AlertMessage from '../../../config/alertMessage';
import Loader from '../../../../common/loader';
import CBT2MockExamsInsructions from '../../../Common/CBT2InstructionsNew';
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from 'reactstrap';
import AppRoutes from '../../../config/AppRoutes';
import { hasMockAccessFromBackend } from '../../../../utils/CommonUtils';
/* eslint-disable*/

class CBT2MockExams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      pdfAlert: false,
      MessageTitle: App_data.messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_cfa_1,
      mockList: [],
      token: '',
      idname: '',
      ValidToken: false,
      subscriptionstatus: '',
      showFreePremium: true,
      selectedmenu: 'cfa_2',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      type: 'question',
      PDFContentMessage: language.LC().PDFContentMessage,
      isLoading: true,
      mockData: '',
      userStatsData: '',
      pdfLoadingQ: false,
      pdfLoadingQA: false,
      pdfMessage: '',
      pdfMessageOpen: false,
      dropdownOpen: false,
      dropdownOpenIndex: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.togglePdfMessage = this.togglePdfMessage.bind(this);
  }

  togglePdfMessage() {
    this.setState({ pdfMessageOpen: !this.state.pdfMessageOpen });
  }

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  checkSubscriptionPartner = () => {
    const { pathname } = this.props.location;
    if (pathname.includes('/cfa3/')) return PartnerCfa3SubscriptionCheck.checkCfa3Subscription;
    return PartnerCfa2SubscriptionCheck.checkCfa2Subscription;
  };

  checkSubscriptionUser = () => {
    const { pathname } = this.props.location;
    if (pathname.includes('/cfa3/')) return Cfa3SubscriptionCheck.checkCfa3Subscription;
    return Cfa2SubscriptionCheck.checkCfa2Subscription;
  };

  //Function to redirect page to viewquestions page
  getQuestions = mock => {
    this.setState({
      showInstructionModal: false,
    });
    var user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;

                isInArray_var = await this.checkSubscriptionPartner(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                const hasMockAccess = hasMockAccessFromBackend(resp_exam.hasMockSubscription);
                if (isInArray_var || hasMockAccess) {
                  this._runCode('paid', mock);
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          // console.log('resp.profileInfo.---------------', resp.profileInfo);
          this.toggleAlert();
          this.setState({ subscriptionstatus: 'free' });
          this._runCode('free');
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              // console.log('resp of get exam by user', resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = this.checkSubscriptionUser(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                const hasMockAccess = hasMockAccessFromBackend(resp_exam.hasMockSubscription);
                // console.log('outside isInArray_var heeee', isInArray_var);
                if (isInArray_var || hasMockAccess) {
                  // console.log('inside isInArray_var ', isInArray_var);
                  this._runCode('paid', mock);
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.toggleAlert();
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  _runCode = (subscriptionstatus, mock) => {
    if (subscriptionstatus === 'paid') {
      const frontendRoute = this.props.location.pathname.includes('/cfa3/')
        ? AppRoutes.CFA3_CBT_INTRODUCTION
        : AppRoutes.CFA2_CBT_INTRODUCTION;
      let pathname = frontendRoute
        .replace(':id', mock.id)
        .replace(':questiono', 1)
        .replace(':timer', mock.timer);
      this.context.router.push({
        pathname,
      });
    }
  };

  //On Page Load,init this method
  async componentDidMount() {
    window.scrollTo(0, 0);
    // console.log('I am on Frontendsrc\viewsCBTCFA2CBTNewMockListindex.js');
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    const filePath = this.props.location.pathname.includes('/cfa3/')
      ? 'cfa3CBTMockExams'
      : 'cfa2CBTMockExams';
    FD.callAPI(App_data.backend_api + `/${filePath}/getCFAMockExams`, data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          mockList: resp.mock,
          isLoading: false,
          userStatsData: resp.userstats,
        });
      } else {
        this.setState({ ValidToken: false, isLoading: false });
      }
      return resp;
    });
  }

  goPremium = () => {
    this.context.router.push({
      pathname: AppRoutes.SUBSCRIBE,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  startExam = mock => {
    this.setState({
      showInstructionModal: true,
      mockData: mock,
    });
  };

  viewAttemptedExams = mock => {
    // ('/cfa2viewattemptedmock/:id/:timer');
    const frontENDURL = this.props.location.pathname.includes('/cfa3/')
      ? AppRoutes.CFA3_CBT_VIEW_ATTEMPTED_MOCK
      : AppRoutes.CFA2_CBT_VIEW_ATTEMPTED_MOCK;

    let path = frontENDURL.replace(':id', mock.id).replace(':timer', mock.timer);
    this.context.router.push({
      pathname: path,
    });
  };

  openQPDF = id => {
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: id,
    };

    const filePath = this.props.location.pathname.includes('/cfa3/')
      ? 'cfa3CBTMockExams'
      : 'cfa2CBTMockExams';
    FD.callAPI(App_data.backend_api + `/${filePath}/MockQPdfDownload`, data).then(resp => {
      if (resp.success) {
        this.setState({
          pdfLoadingQ: false,
        });
        var myWindow = window.open(resp.DownloadLink);
        myWindow.focus();
      } else {
        // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
        this.setState({
          pdfLoadingQ: false,
          pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
          pdfMessageOpen: true,
        });
      }
      return resp;
    });
  };

  openQAPDF = id => {
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: id,
    };
    const filePath = this.props.location.pathname.includes('/cfa3/')
      ? 'cfa3CBTMockExams'
      : 'cfa2CBTMockExams';
    FD.callAPI(App_data.backend_api + `/${filePath}/MockQAPdfDownload`, data).then(resp => {
      if (resp.success) {
        this.setState({
          pdfLoadingQA: false,
        });
        var myWindow = window.open(resp.DownloadLink);
        myWindow.focus();
      } else {
        // No PDF generated yet — stop the spinner and tell the user instead of a silent click.
        this.setState({
          pdfLoadingQA: false,
          pdfMessage: resp.message || 'The PDF for this mock is not available yet.',
          pdfMessageOpen: true,
        });
      }
      return resp;
    });
  };

  checkSubscription = (id, type) => {
    var user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                // console.log('resp.profileInfo.userStatus', resp.profileInfo);
                isInArray_var = await PartnerCfa2SubscriptionCheck.checkCfa2Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                const hasMockAccess = hasMockAccessFromBackend(resp_exam.hasMockSubscription);
                if (isInArray_var || hasMockAccess) {
                  if (type === 'Q') {
                    this.setState({
                      pdfLoadingQ: true,
                    });
                    this.openQPDF(id);
                  } else {
                    this.setState({
                      pdfLoadingQA: true,
                    });
                    this.openQAPDF(id);
                  }
                } else {
                  this.toggleAlert();
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              // console.log('resp of get exam by user', resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = this.checkSubscriptionUser(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                const hasMockAccess = hasMockAccessFromBackend(resp_exam.hasMockSubscription);
                // console.log('outside isInArray_var heeee', isInArray_var);
                if (isInArray_var || hasMockAccess) {
                  // console.log('inside isInArray_var ', isInArray_var);

                  if (type === 'Q') {
                    this.setState({
                      pdfLoadingQ: true,
                    });
                    this.openQPDF(id);
                  } else {
                    this.setState({
                      pdfLoadingQA: true,
                    });
                    this.openQAPDF(id);
                  }
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.toggleAlert();
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  toggle = index => {
    this.setState({
      dropdownOpenIndex: index,
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  render() {
    const {
      mockList,
      isLoading,
      showInstructionModal,
      mockData,
      dropdownOpen,
      dropdownOpenIndex,
    } = this.state;
    return (
      <div>
        <div className='animated fadeIn'>
          <div className='row'>
            <div className='col-md-8 margin_bottom_20'>
              <h1 className='section_head'>{language.LC().MOCK_LIST}</h1>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <div className='card height_70vh'>
                <div className='table_responsive_wrapper'>
                  <div className='table-responsive'>
                    <table className='table_white_bg table'>
                      <thead>
                        <tr className='border_top_0'>
                          <th width='90'>#</th>
                          <th className='mw-190'>{language.LC().MOCKEXAM}</th>
                          <th className='w-280 text-center'>{language.LC().ACTION}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <Loader />
                        ) : mockList.length ? (
                          mockList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.id}</td>
                                <td>
                                  <div>{item.mock_exam}</div>
                                </td>
                                <td>
                                  <span
                                    className='btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20'
                                    onClick={() => this.viewAttemptedExams(item)}
                                  >
                                    {language.LC().START}
                                  </span>
                                  <span className='privetinfo-dropdown'>
                                    <ButtonDropdown
                                      className={index + 1 === mockList.length ? 'dropup' : ''}
                                      isOpen={dropdownOpenIndex === index ? dropdownOpen : false}
                                      toggle={() => this.toggle(index)}
                                    >
                                      <DropdownToggle
                                        className='btn btn-primary pointer_class small-btn tooltip_wrap margin_right_20'
                                        caret
                                      >
                                        {language.LC().PRINT}
                                      </DropdownToggle>
                                      <DropdownMenu right>
                                        <DropdownItem
                                          value='public'
                                          onClick={() => {
                                            this.checkSubscription(item.id, 'Q');
                                          }}
                                        >
                                          <i
                                            className='fa fa-print color-black'
                                            aria-hidden='true'
                                          />
                                          {language.LC().PRINT_CASES_Q_MOCK}
                                        </DropdownItem>
                                        <DropdownItem
                                          value='private'
                                          onClick={() => {
                                            this.checkSubscription(item.id, 'QA');
                                          }}
                                        >
                                          <i
                                            className='fa fa-print color-black'
                                            aria-hidden='true'
                                          />
                                          {language.LC().PRINT_CASES_QA_MOCK}
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </ButtonDropdown>
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={'4'} className={'text-center py-4 px-2'}>
                              <div className='no-qus-found no-mock-exam'>
                                <img
                                  width='80px'
                                  src={App_data.frontend_url + '/img/questions/problem.png'}
                                />
                                <h3>{language.LC().No_Mock_Exams}</h3>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
        <Modal
          isOpen={this.state.pdfMessageOpen}
          toggle={this.togglePdfMessage}
          className='modal-primary custom_modalpro info-modal-designing'
        >
          <ModalHeader toggle={this.togglePdfMessage} className='custom-title'>
            Information
          </ModalHeader>
          <ModalBody>
            <div className='modal-info-view-for-plan'>
              <p>{this.state.pdfMessage}</p>
              <div className='btn-plan-view view-plan-wrap'>
                <Button className='btn btn-primary' onClick={this.togglePdfMessage}>
                  OK
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <CBT2MockExamsInsructions
          showInstructionModal={showInstructionModal}
          getQuestions={() => this.getQuestions(mockData)}
          handleClose={() => this.setState({ showInstructionModal: false })}
        />
      </div>
    );
  }
}

export default CBT2MockExams;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA2CBTNew/MockList/index.js